import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import $ from 'jquery';
import LabelInput from '../../elements/LabelImput';
import { injectPhpDebug } from '../../../../mol_function';

import './index.scss';
import AdressComponnent, {
  AdressComponnentProp,
  getEmptyAddressProp,
} from '../../elements/AdressComponnent';
import PasswordInput from '../../elements/PasswordInput';

import img_PAYPAL from './parts/images/PAYPAL.png';
import img_VISA from './parts/images/VISA.png';
import img_MASTER from './parts/images/MASTER.png';
import img_DIRECTDEBIT_SEPA from './parts/images/DIRECTDEBIT_SEPA.png';
import img_BAG from './parts/images/BAG.svg.png';
import img_BUCH_RECHNUNG from './parts/images/buchbutler_rechnungskauf.png';
import BuchhandlerInput from '../../elements/BuchhandlerInput';

interface Checkout_VRState extends BasePageState {
  checkoutID?: string;
  validEmail?: boolean;
  enableNext: boolean;
  enableBussy: boolean;
  schippingAddress?: AdressComponnentProp;
  isDeliveryAdressValid: boolean;
  isBillingAdressValid: boolean;
  billigAddress?: AdressComponnentProp;
  loginError: boolean;
  pendingReqest?: Promise<Response>;
  paymentItem?: {
    paymentType: string;
    url?: string;
    sessionID?: string;
    orderGUID: string;
    checkOutReady: boolean;
  };
}
interface Checkout_VRModel {}

export default class Checkout_VRPage extends Basepage<
  Checkout_VRState,
  Checkout_VRModel
> {
  constructor(prop: Checkout_VRModel) {
    super(prop);
  }

  onEmailReady() {
    if (this.state.pendingReqest != undefined) {
      return;
    }

    this.setState({ enableNext: false });
    let email = $('#email').val();
    if (email != undefined && typeof email === 'string') {
      if (email.trim() == '') {
        return;
      }
      let apiUrl = injectPhpDebug(
        this.state.apiBase +
          '/Checkout_VR.php?checkEmail=' +
          encodeURIComponent(email),
      );

      let reqest = fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      this.setState({ pendingReqest: reqest });

      reqest
        .then((response) => response.json())
        .then((data) => {
          let validEmail: boolean = data.body.validEmail;
          let newState: any = {
            validEmail: validEmail,
            schippingAddress: undefined,
            loginError: false,
            pendingReqest: undefined,
          };

          if (!validEmail) {
            let newAdress =
              this.state.schippingAddress != undefined
                ? this.state.schippingAddress
                : getEmptyAddressProp(this.state.apiData.body.countrys);
            newState.schippingAddress = newAdress;
          }
          this.setState(newState);
        });
    }
  }

  translateAdressApiToModel(
    dataItem,
    countrys,
    readOnly,
  ): AdressComponnentProp {
    return translateAdressApiToModelExtern(dataItem, countrys, readOnly);
  }

  onPasswordReady() {
    this.setState({ enableNext: false });
    let email = $('#email').val();
    let pass = $('#login-password').val();
    if (
      email != undefined &&
      (typeof email === 'string' || email instanceof String) &&
      pass != undefined &&
      (typeof pass === 'string' || pass instanceof String)
    ) {
      let apiUrl = injectPhpDebug(
        this.state.apiBase +
          '/Checkout_VR.php?tryLogin=' +
          encodeURIComponent(email) +
          '&pass=' +
          encodeURIComponent(pass),
      );

      fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
        .then((response) => response.json())
        .then((data) => {
          let loginSuccess = data.body.loginSucess;
          let newState: any = {};
          newState.schippingAddress = undefined;
          newState.loginError = !loginSuccess;
          if (loginSuccess) {
            newState.apiData = data.body;
            let dataItem: any = data.body.addresse.find(
              (f) => f.isShippingDefault,
            );

            if (dataItem == undefined && data.body.addresse.length > 0) {
              dataItem = data.body.addresse[0];
            }

            newState.schippingAddress = this.translateAdressApiToModel(
              dataItem,
              data.body.countrys,
              false,
            );
          }
          this.setState(newState);
        });
    }
  }

  onPaymentChange(payment: string) {
    let apiUrl = injectPhpDebug(
      this.state.apiBase +
        '/Checkout_VR.php?changePayment=' +
        encodeURIComponent(payment),
    );

    let form = $('#checkout');
    let formSerializeData = form.serialize();
    let keyValuePair = formSerializeData.split('&');
    let result = {};
    for (let i = 0; i < keyValuePair.length; i++) {
      let kvSplit = keyValuePair[i].split('=');
      if (kvSplit[1].trim() != '') result[kvSplit[0]] = decodeURI(kvSplit[1]);
      else result[kvSplit[0]] = null;
    }

    let jsonBody = JSON.stringify(result);

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: jsonBody,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.REDIRECT != undefined) {
          let winAny: any = window;
          winAny.historyHelper.memory.push(data.REDIRECT, null);
        } else {
          let vrPaypaymentType = [
            //'PAYPAL',
            'VISA',
            'MASTER',
            'DIRECTDEBIT_SEPA',
          ];

          let paymentType = data.body.paymentType;

          let sessionID: string | undefined = undefined;
          let url: string | undefined = undefined;
          let orderGUID: string = data.body.orderGUID;

          let checkOutReady = false;

          if (vrPaypaymentType.includes(paymentType)) {
            sessionID = data.body.data.id;

            let baseUrl = data.body.baseUrl;

            url = baseUrl + '/v1/paymentWidgets.js?checkoutId=' + sessionID;
          } else if (paymentType.substr(0, 3) == 'PO_') {
            url = data.body.url;
          } else if (paymentType == 'BAG' || paymentType == 'BUCH_RECHNUNG') {
            checkOutReady = true;
          } else if (paymentType == 'PAYPAL') {
            url = data.body.pay_url;
          }

          this.setState({
            paymentItem: {
              paymentType: paymentType,
              url: url,
              sessionID: sessionID,
              orderGUID: orderGUID,
              checkOutReady: checkOutReady,
            },
          });

          setTimeout(() => {
            if (this.state.paymentItem != undefined) {
              let htmlItem = document.getElementById('formContainer');
              let jsItem = document.getElementById('jsScriptContainer');
              if (htmlItem != null && jsItem != null) {
                htmlItem.innerHTML = '';
                jsItem.innerHTML = '';
                let urlCallback =
                  this.state.renderingDomain +
                  '/paymentResult?paymentType=' +
                  this.state.paymentItem.paymentType +
                  '&orderGUID=' +
                  this.state.paymentItem.orderGUID;
                if (vrPaypaymentType.includes(paymentType)) {
                  let sessionID = this.state.paymentItem?.sessionID;
                  let url = this.state.paymentItem?.url;
                  if (sessionID != undefined && url != undefined) {
                    let dataBranch = this.state.paymentItem.paymentType;

                    let form = document.createElement('form');
                    form.setAttribute('action', urlCallback);
                    form.setAttribute('class', 'paymentWidgets');
                    form.setAttribute('data-brands', dataBranch);

                    htmlItem.append(form);

                    let script = document.createElement('script');
                    script.setAttribute('src', url);
                    jsItem.append(script);
                  }
                } else if (paymentType.substr(0, 3) == 'PO_') {
                  let paymentUrl = this.state.paymentItem?.url;
                  if (paymentUrl != undefined) {
                    let a = document.createElement('a');
                    a.href = paymentUrl;
                    let img = document.createElement('img');
                    img.setAttribute(
                      'src',
                      this.paymentTypeToImage(paymentType),
                    );
                    img.style = 'height: 120px;     border: solid #ccc;';
                    a.appendChild(img);
                    htmlItem.append(a);
                  }
                } else if (this.state.paymentItem.paymentType == 'BAG') {
                  let img = document.createElement('img');
                  img.setAttribute('src', img_BAG);
                  /*
                img.onclick = () => {
                  debugger;
                };
                img.style.cursor = 'pointer';
                */
                  img.style.height = '120px';

                  htmlItem.append(img);
                } else if (
                  this.state.paymentItem.paymentType == 'BUCH_RECHNUNG'
                ) {
                  let img = document.createElement('img');
                  img.setAttribute('src', img_BUCH_RECHNUNG);
                  /*
                img.onclick = () => {
                  debugger;
                };
                img.style.cursor = 'pointer';
                */
                  img.style.height = '120px';

                  htmlItem.append(img);
                } else if (this.state.paymentItem.paymentType == 'PAYPAL') {
                  let a = document.createElement('a');
                  a.href = this.state.paymentItem.url;
                  let img = document.createElement('img');
                  img.setAttribute('src', img_PAYPAL);
                  img.style = 'height: 120px;     border: solid #ccc;';
                  a.appendChild(img);
                  htmlItem.append(a);
                }
              }
            }
          }, 500);
        }
      });
  }

  paymentTypeToImage(name: string) {
    let images = {
      DIRECTDEBIT_SEPA: img_DIRECTDEBIT_SEPA,
      MASTER: img_MASTER,
      PAYPAL: img_PAYPAL,
      VISA: img_VISA,
      BAG: img_BAG,
      BUCH_RECHNUNG: img_BUCH_RECHNUNG,
      PO_CC_V: img_VISA,
      PO_CC_M: img_MASTER,
      PO_ELV: img_DIRECTDEBIT_SEPA,
    };
    let imagesSrc = images[name];
    return imagesSrc;
  }

  createPayRadio(name: string) {
    let imagesSrc = this.paymentTypeToImage(name);
    return (
      <>
        <input
          type="radio"
          name={'payMethod'}
          tabIndex={1}
          id={'payMethod_' + name}
          value={name}
          className="radioPos"
          onChange={(ev) => {
            let paymentMethod = ev.target.value;
            this.onPaymentChange(paymentMethod);
          }}
        />
        <label htmlFor={'payMethod_' + name}>
          {imagesSrc != undefined ? (
            <img src={imagesSrc} />
          ) : (
            <span>{name}</span>
          )}
        </label>
      </>
    );
  }

  renderChild(): JSX.Element {
    let isLogin = this.state.apiData.isLogin;

    let schippingAddress = this.state.schippingAddress;

    let buchHandlerPreValid = false;

    let anyProp: any = this.props;

    if (
      anyProp.mode != 'ssr' &&
      this.state.validEmail != undefined &&
      this.state.isBuchhandler
    ) {
      if (isLogin) {
        buchHandlerPreValid = true;
      } else {
        let v1 = false;
        let tmp1: any = $('#yes_handler');
        if (tmp1 != null && tmp1[0] != undefined && tmp1[0].checked == true)
          v1 = true;
        let v2 = $('#verkehrsnummer').val();
        if (v1 && v2 != '') buchHandlerPreValid = true;
      }
    } else buchHandlerPreValid = true;

    let showPaymentBox =
      buchHandlerPreValid &&
      this.state.isDeliveryAdressValid != false &&
      (this.state.billigAddress == undefined ||
        (this.state.billigAddress != undefined &&
          this.state.isBillingAdressValid));

    let ErrorMessage = '';
    if (!showPaymentBox) {
      if (buchHandlerPreValid == false) {
        ErrorMessage +=
          'Bitte geben Sie Ihre Verkehrsnummer ein und bestätigen Sie, dass Sie Buchhändler oder Wiederverkäufer sind.\n' +
          'Sollten Sie keine Verkehrsnummer führen, melden Sie sich bitte telefonisch bei uns.';
      }
      if (this.state.isDeliveryAdressValid == false) {
        ErrorMessage +=
          'Ihre Lieferadresse ist nicht vollständig.  Bitte wählen Sie eine Anrede.\n';
      }
      if (
        this.state.billigAddress != undefined &&
        !this.state.isBillingAdressValid
      ) {
        ErrorMessage +=
          'Ihre Rechnungsadresse ist nicht vollständig.  Bitte wählen Sie eine Anrede\n';
      }
    }

    let paymentDivDynamicStyle: React.CSSProperties = {};

    /*
    if (this.state?.paymentItem?.paymentType.substring(0, 3) == 'PO_') {
      let positionCount = (this.state.apiData.articleCount + 1) * 20;
      paymentDivDynamicStyle.height = 470 + positionCount + 'px';
    }
    */

    let showBag = false;
    if (this.state.apiData.body.BAG_ERLAUBT == true) {
      showBag = true;
    }

    return (
      <div id="checkout_VR">
        <form
          id="checkout"
          onSubmit={(event) => {
            event.preventDefault();
          }}
        >
          {isLogin == false ? (
            <>
              <LabelInput
                id="email"
                labelText="E-Mail Adresse"
                type="text"
                name="email"
                inputDynparam={{ size: 36, maxLength: 96 }}
                requied={true}
                onChange={(ev) => {}}
                onBlur={(ev) => {
                  this.onEmailReady();
                }}
              />
              {this.state.validEmail ? (
                <PasswordInput
                  onBlur={(ev) => {
                    this.onPasswordReady();
                  }}
                  showLost={true}
                />
              ) : this.state.validEmail == false && this.state.isBuchhandler ? (
                <BuchhandlerInput
                  isNotValidExit={true}
                  cookieDomain={this.state.apiData.cookieDomain}
                  isValidNotify={(isValid) => {}}
                />
              ) : null}
              {this.state.loginError ? <span>Fehler beim Anmelden</span> : null}
            </>
          ) : null}
          {schippingAddress != undefined ? (
            <>
              <fieldset className="fsWidth_L">
                <legend>Lieferanschrift</legend>
                {this.state.apiData.body.addresse?.length > 1 ? (
                  <select
                    value={this.state.schippingAddress?.adress_id}
                    onChange={(ev) => {
                      let newId = ev.target.value;
                      let apiData = this.state.apiData.body;

                      let apiItem = apiData.addresse.find(
                        (f) => f.adress_id == newId,
                      );
                      let newShipping = translateAdressApiToModelExtern(
                        apiItem,
                        apiData.countrys,
                        false,
                      );
                      this.setState({ schippingAddress: newShipping });
                    }}
                  >
                    {this.state.apiData.body.addresse.map((item, index) => {
                      return (
                        <option
                          value={item.adress_id}
                          key={'option_schipping_' + item.adress_id}
                        >
                          {item.company} - {item.firstname} {item.lastname} -{' '}
                          {item.stret} {item.house_number} - {item.postcode}{' '}
                          {item.city} - {item.department} {item.additive1}{' '}
                          {item.additive2}
                        </option>
                      );
                    })}
                  </select>
                ) : null}

                <AdressComponnent
                  {...schippingAddress}
                  idPostfix="_schipping"
                  isValidNotify={(isValid) => {
                    if (this.state.isDeliveryAdressValid != isValid) {
                      this.setState({ isDeliveryAdressValid: isValid });
                    }
                    /*Bei nicht ausgefülltem Adressefeld, dürfen die Zahlarten nicht angezeigt werden.*/
                  }}
                />
                {this.state.isDeliveryAdressValid != true ? (
                  <span
                    className="errorText"
                    style={{ fontWeight: 'bold', fontSize: 'x-large' }}
                  >
                    *Bitte alle Pflichtfelder ausfüllen
                  </span>
                ) : null}
              </fieldset>
              {showPaymentBox ? (
                <fieldset className="paymentPos">
                  <legend>Wählen Sie ihre Zahlungsart</legend>
                  <div className="paymentBox">
                    {this.state.isBuchhandler ? (
                      <>
                        {this.createPayRadio('BUCH_RECHNUNG')}
                        {showBag ? this.createPayRadio('BAG') : <></>}
                      </>
                    ) : null}
                    {/* 
                    {this.createPayRadio('PAYPAL')}
                    */}
                    {/* 
                    {this.createPayRadio('PO_CC_V')}
                    {this.createPayRadio('PO_CC_M')}
                    {this.createPayRadio('PO_ELV')}
                    */}
                    {/*
                    {this.createPayRadio('VISA')}
                    {this.createPayRadio('MASTER')}
                    {this.createPayRadio('DIRECTDEBIT_SEPA')}
                     */}
                  </div>
                </fieldset>
              ) : (
                <div>
                  {ErrorMessage.split('\n')
                    .map((m) => m)
                    .reduce((prev, next) => (
                      <>
                        {prev}
                        <br />
                        {next}
                      </>
                    ))}
                </div>
              )}
              <br className="clearBoth" />
              <input
                type="checkbox"
                onChange={(ev) => {
                  let newState: any = {};
                  if (ev.target.checked) {
                    newState.billigAddress = getEmptyAddressProp(
                      this.state.apiData.body.countrys,
                    );
                  } else newState.billigAddress = undefined;
                  this.setState(newState);
                }}
                name="diffBilligAddress"
                defaultChecked={this.state.billigAddress != undefined}
              />
              <span>Abweichende Rechnungsanschrift?</span>
              <br className="clearBoth" />
              {this.state.billigAddress ? (
                <fieldset className="fsWidth">
                  <legend>Rechnungsanschrift</legend>
                  {this.state.apiData.body.addresse?.length > 1 ? (
                    <select
                      value={this.state.billigAddress.adress_id}
                      onChange={(ev) => {
                        let newId = ev.target.value;
                        let apiData = this.state.apiData.body;

                        let apiItem = apiData.addresse.find(
                          (f) => f.adress_id == newId,
                        );
                        let newbillig = translateAdressApiToModelExtern(
                          apiItem,
                          apiData.countrys,
                          false,
                        );
                        this.setState({ billigAddress: newbillig });
                      }}
                    >
                      {this.state.apiData.body.addresse.map((item, index) => {
                        return (
                          <option
                            value={item.adress_id}
                            key={'option_billing_' + item.adress_id}
                          >
                            {item.company} - {item.firstname} {item.lastname} -{' '}
                            {item.stret} {item.house_number} - {item.postcode}{' '}
                            {item.city} - {item.department} {item.additive1}{' '}
                            {item.additive2}
                          </option>
                        );
                      })}
                    </select>
                  ) : null}
                  <AdressComponnent
                    {...this.state.billigAddress}
                    idPostfix="_billig"
                    isValidNotify={(isValid) => {
                      if (this.state.isBillingAdressValid != isValid) {
                        this.setState({ isBillingAdressValid: isValid });
                      }
                      /*Bei nicht ausgefülltem Adressefeld, dürfen die Zahlarten nicht angezeigt werden.*/
                    }}
                  />
                  {this.state.isBillingAdressValid != true ? (
                    <span
                      className="errorText"
                      style={{ fontWeight: 'bold', fontSize: 'x-large' }}
                    >
                      *Bitte alle Pflichtfelder ausfüllen
                    </span>
                  ) : null}
                </fieldset>
              ) : null}
              <br />
            </>
          ) : null}
        </form>

        {this.state.paymentItem != undefined ? (
          <div className="checkoutPopup">
            <div
              className={
                'payment' + (this.state.isBuchhandler ? ' buchhandler ' : '')
              }
              style={paymentDivDynamicStyle}
            >
              <div
                className="closePopoup"
                onClick={() => {
                  this.setState({ paymentItem: undefined });
                  $('input[name=payMethod]').prop('checked', false);
                }}
              >
                X
              </div>
              <div>
                {this.state.paymentItem.checkOutReady ? (
                  <h3>Kauf abschließen mit:</h3>
                ) : (
                  <h3>Weiter zur Zahlung mit:</h3>
                )}
              </div>
              <div id="jsScriptContainer"></div>
              <div id="formContainer"></div>
              {this.state.paymentItem != undefined &&
              this.state.paymentItem.checkOutReady ? (
                <>
                  <button
                    onClick={() => {
                      if (this.state.paymentItem != undefined) {
                        let callBack =
                          '/paymentResult?paymentType=' +
                          this.state.paymentItem.paymentType +
                          '&orderGUID=' +
                          this.state.paymentItem.orderGUID;
                        let windowAny: any = window;

                        if (
                          windowAny.historyHelper != undefined &&
                          windowAny.historyHelper.browser != undefined
                        ) {
                          windowAny.historyHelper.browser.push(callBack);
                        }
                      }
                    }}
                  >
                    Kauf Abschließen
                  </button>
                </>
              ) : null}
            </div>
          </div>
        ) : null}
        {this.state.enableBussy == false &&
        this.state.schippingAddress == undefined ? (
          <>
            <br className="clearBoth" />
            <button
              disabled={this.state.enableNext}
              onClick={() => {
                if (this.state.validEmail == undefined) {
                  this.onEmailReady();
                } else {
                  this.onPasswordReady();
                }
              }}
            >
              Weiter
            </button>
          </>
        ) : null}
      </div>
    );
  }
  initState(base: BasePageState): Checkout_VRState {
    let anyProps: any = this.props;
    let apiData = anyProps.apiData;

    let apiPackage = this.parseApiDataForState(apiData);

    let newState: Checkout_VRState = {
      ...base,
      isDeliveryAdressValid: false,
      checkoutID: undefined,
      validEmail: undefined,
      enableNext: false,
      enableBussy: false,
      loginError: false,
      schippingAddress: apiPackage.shippingAdress,
      billigAddress: apiPackage.billigAddress,
      isBillingAdressValid: false,
    };

    return newState;
  }

  parseApiDataForState(apiData: any): {
    isLogin: boolean;
    shippingAdress: AdressComponnentProp | undefined;
    billigAddress: AdressComponnentProp | undefined;
  } {
    let isLogin: boolean = false;
    let shippingAdress: AdressComponnentProp | undefined = undefined;
    let billigAddress: AdressComponnentProp | undefined = undefined;

    if (apiData != null) {
      isLogin = apiData.isLogin;
    }

    if (isLogin) {
      let shippingAdressApi = apiData.body.addresse?.find(
        (f) => f.isShippingDefault,
      );

      if (shippingAdressApi != undefined) {
        shippingAdress = this.translateAdressApiToModel(
          shippingAdressApi,
          apiData.body.countrys,
          false,
        );

        let billigAdressApi = apiData.body.addresse?.find(
          (f) => f.isBillingDefault,
        );

        if (
          shippingAdressApi != undefined &&
          billigAdressApi != undefined &&
          shippingAdressApi.adress_id != billigAdressApi.adress_id
        ) {
          billigAddress = this.translateAdressApiToModel(
            billigAdressApi,
            apiData.body.countrys,
            false,
          );
        }
      }
    }

    return {
      isLogin: isLogin,
      shippingAdress: shippingAdress,
      billigAddress: billigAddress,
    };
  }

  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Checkout_VR.php';
  }
  /*
  getJSLink(baseUrl: string, sessionID: string) {
    let link = baseUrl + '/v1/paymentWidgets.js?checkoutId=' + sessionID;
    return link;
  }
  */

  releaseOneCommand(): void {}
  childDidMount(): void {
    if (this.state.hasApiData) {
      let prapareData = this.parseApiDataForState(this.state.apiData);
      if (
        this.state.schippingAddress != prapareData.shippingAdress ||
        this.state.billigAddress != prapareData.shippingAdress
      ) {
        this.setState({
          schippingAddress: prapareData.shippingAdress,
          billigAddress: prapareData.billigAddress,
        });
      }
    }
  }
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Kasse';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Kasse</span>;
  }
  getType(): string {
    return 'Checkout_VRPage';
  }
}

export function translateAdressApiToModelExtern(
  dataItem,
  countrys,
  readOnly,
): AdressComponnentProp {
  let countryIso = countrys.find(
    (f) => f.id == dataItem.country_id,
  )?.iso_code_2;

  return {
    adress_id: dataItem.adress_id,
    gender: dataItem.gender,
    firma: dataItem.company,
    vorname: dataItem.firstname,
    nachname: dataItem.lastname,
    strasse: dataItem.stret,
    hausnummer: dataItem.house_number,
    abteilung: dataItem.department,
    zusatz1: dataItem.additive1,
    zusatz2: dataItem.additive2,
    zip: dataItem.postcode,
    ort: dataItem.city,
    country_id: dataItem.country_id,
    country_ISO2: countryIso,
    countrys: countrys,
    readonly: readOnly,
  };
}
